import * as React from 'react';

import HelpRounded from '@material-ui/icons/HelpRounded';
import OrderTypeToggle from '../common/OrderTypeToggle';
import StoreHours from './StoreHours';
import PropTypes from 'prop-types';

import styles from './Header.module.css';

const DeliveryDetails = ({
  deliveryFee,
  deliveryDateOffset,
  handleShowSchedule,
  handlePickupToggle
}) => {
  return (
    <>
      <div className={styles.serviceDetails}>
        <div className={`${styles.serviceDetail} ${styles.detailLink}`} onClick={handleShowSchedule}>
          <div className={styles.detailValue}>{deliveryDateOffset === 0 ? 'Today' : 'Tomorrow'}</div>
          <div className={styles.detailLabel}>
            Delivery Schedule{' '}
            <HelpRounded style={{
              cursor:'pointer',
              verticalAlign:'text-bottom',
              fontSize: 20
            }} /> 
          </div>
        </div>
        <div className={styles.serviceDetail}>
          <div className={styles.detailValue}>{deliveryFee}</div>
          <div className={styles.detailLabel}>Delivery Fee</div>
        </div>
      </div>
      <div className={styles.toggleWrap}> 
        <OrderTypeToggle inBody isPickup={false} handlePickupClick={handlePickupToggle} />
      </div>
      <div className={styles.storeHours}>
        <StoreHours />
      </div>
    </>    
  )
}

DeliveryDetails.propTypes = {
  deliveryFee: PropTypes.string.isRequired,
  deliveryDateOffset: PropTypes.number.isRequired,
  handleShowSchedule: PropTypes.func.isRequired,
  handlePickupToggle: PropTypes.func.isRequired
}

export default DeliveryDetails;